<div
    class="flex items-center justify-center space-x-4 text-xs font-medium text-gray-400 dark:text-gray-100"
>
    <!-- Toggle Slider -->
    <div
        class="relative w-12 h-6 bg-gray-300 dark:bg-gray-600 rounded-full transition-colors duration-300 cursor-pointer"
        (click)="toggleScheme()"
    >
        <!-- Sun/Moon icons inside slider -->
        <div
            class="absolute left-1 top-1 w-4 h-4"
            *ngIf="config.scheme !== 'dark'"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 text-gray-900"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 3v1m0 16v1m8.66-10H21m-16.66 0H3m15.36 6.36l-.7.7M6.34 6.34l-.7.7m0 9.92l.7.7M17.66 6.34l.7.7M12 8a4 4 0 100 8 4 4 0 000-8z"
                />
            </svg>
        </div>

        <div
            class="absolute right-1 top-1 w-4 h-4"
            *ngIf="config.scheme === 'dark'"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
                />
            </svg>
        </div>

        <!-- Slider Thumb -->
        <div
            class="absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform duration-300"
            [ngStyle]="{
                transform:
                    config.scheme === 'light'
                        ? 'translateX(24px)'
                        : config.scheme === 'auto'
                        ? 'translateX(12px)'
                        : 'translateX(0px)'
            }"
        ></div>
    </div>
</div>
